import React, { useEffect, useState } from 'react'
import { Autocomplete } from '@material-ui/lab'
import { CircularProgress, TextField } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

const AutocompleteTypeAndSearch = ({
  textField = {},
  requestToLoadOptions,
  name = '',
  minCharsToSearch = 3,
  multiple = false,
  defaultValue,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState('')
  const [options, setOptions] = useState([])
  const [loadingOptions, setLoadingOptions] = useState(false)

  const { control } = useFormContext()

  const getOptionLabel = (option) => {
    return option?.name || ''
  }

  const getOptionSelected = (option, value) => {
    if (!value) return false

    return option?.id === value.id || value.id === 0
  }

  const noOptionTextInstructions = () => {
    if (loadingOptions) return 'Carregando...'
    if (inputValue.length < minCharsToSearch)
      return `Digite no mínimo ${minCharsToSearch} letras pra buscar`

    return 'Sem opções'
  }

  const handleTypeInputValue = (e) => {
    setInputValue(e.target.value)
  }

  const fetchOptions = async () => {
    setLoadingOptions(true)

    const fetchedOptions = await requestToLoadOptions(inputValue)

    setLoadingOptions(false)
    setOptions(fetchedOptions)
  }

  useEffect(() => {
    const delayRequest = setTimeout(() => {
      if (inputValue.length >= minCharsToSearch) {
        fetchOptions()
      }
    }, 1000)

    return () => clearTimeout(delayRequest)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue])

  return (
    <Controller
      as={
        <Autocomplete
          getOptionLabel={getOptionLabel}
          getOptionSelected={getOptionSelected}
          noOptionsText={noOptionTextInstructions()}
          options={options}
          multiple={multiple}
          {...rest}
          renderInput={(params) => (
            <TextField
              {...params}
              {...textField}
              onChange={handleTypeInputValue}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingOptions ? (
                      <CircularProgress color="primary" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      }
      control={control}
      name={name}
      mode="onBlur"
      onChange={([, data]) => data}
      defaultValue={
        defaultValue !== undefined ? defaultValue : multiple ? [] : null
      }
    />
  )
}

export default AutocompleteTypeAndSearch
